import { Property } from "@common/properties/property.model";
import { DataTable } from "components/elements/Datatable/data-table";
import { PropertiesTable } from "./components/properties-table";
import { PropertyForm } from "./components/property-form";
import WidgetBox from "components/elements/WidgetBox/widget-box";

type PropertiesProps = {
  companyId: string;
  entityId?: string;
};

export function Properties({ companyId, entityId }: PropertiesProps) {
  const params: Record<string, string> = {
    company: companyId,
  };

  if (entityId) {
    params.entity = entityId;
  }

  return (
    <WidgetBox>
      <DataTable<Property>
        resource={{
          path: "properties",
          name: "Property",
          title: "Properties",
        }}
        table={<PropertiesTable />}
        form={<PropertyForm />}
        params={params}
      />
    </WidgetBox>
  );
}
